import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";

const STATS = [
  { value: "4.9★", label: "calificación promedio" },
  { value: "+1.000", label: "hogares decorados en Colombia" },
  { value: "98%", label: "lo recomienda a un amigo" },
];

const TESTIMONIALS = [
  {
    quote:
      "Pedí el retrato de mi perrita y quedó idéntico. Lo tengo en la sala y todo el que llega pregunta dónde lo hice.",
    author: "Laura, Bogotá",
  },
  {
    quote:
      "Llegó súper bien empacado y antes de lo que esperaba. La calidad del MDF se nota apenas lo tienes en las manos.",
    author: "Andrés, Medellín",
  },
  {
    quote:
      "Compré dos para regalar y terminé pidiendo uno para mí. El proceso fue facilísimo y el resultado, hermoso.",
    author: "Camila, Cúcuta",
  },
];

const Stars = () => (
  <span className="inline-flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        className="h-3.5 w-3.5 text-[#E85A3C] fill-[#E85A3C]"
        strokeWidth={0}
      />
    ))}
  </span>
);

export const SocialProofStrip = () => {
  return (
    <section
      data-testid="social-proof-section"
      className="bg-white py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats */}
        <div
          data-testid="social-proof-stats"
          className="flex flex-wrap items-center justify-center gap-x-12 gap-y-4 mb-10 md:mb-14"
        >
          {STATS.map((s) => (
            <div key={s.label} className="text-center">
              <span className="block font-serif text-2xl md:text-3xl text-slate-900">
                {s.value}
              </span>
              <span className="text-xs md:text-sm text-slate-500">
                {s.label}
              </span>
            </div>
          ))}
        </div>

        {/* Testimonios */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.author}
              data-testid={`social-proof-testimonial-${i + 1}`}
              className="rounded-2xl border border-slate-200 bg-slate-50 p-6 flex flex-col gap-3"
            >
              <Stars />
              <blockquote className="font-serif text-base text-slate-800 leading-relaxed">
                “{t.quote}”
              </blockquote>
              <figcaption className="text-sm text-slate-500 mt-auto">
                {t.author}
              </figcaption>
            </figure>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 md:mt-12 text-center">
          <Link
            to="/categorias"
            data-testid="social-proof-cta"
            className="group inline-flex items-center gap-2 bg-[#E85A3C] hover:bg-[#D3492D] text-white px-8 py-3.5 rounded-full font-medium text-sm md:text-base shadow-lg shadow-[#E85A3C]/30 transition-all duration-300 hover:-translate-y-0.5"
          >
            Encuentra tu cuadro
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <p className="mt-3 text-xs text-slate-500">
            Envío gratis desde $200.000 · Pago seguro · 12 categorías
          </p>
        </div>
      </div>
    </section>
  );
};
